'use strict';
var isObject = require('../internals/is-object');

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-object.js
// module id = 18
// module chunks = 0